export const EMAIL_COMPOSER_IDS = {
  message: 'message-composer',
  review: 'work-review-composer',
  chapterComment: 'chapter-comment-composer',
  articleComment: 'article-comment-composer',
  comment: 'comment-composer',
} as const;

export const PROFILE_EMAIL_SECTION_ID = 'email';
export const CONFIRM_EMAIL_BUTTON_ID = 'confirm-email-button';
export const VERIFICATION_CODE_INPUT_ID = 'verification-code';
